export enum MotivoNaoElegivelEnum {
  Estagio = 0,
  AdiantamentoEmProgresso = 1,
  Genero = 2,
  Pais = 3,
  DistroEmProgresso = 4,
}
